import React from 'react';
import NavBar from '../../components/Navbar/NavBar';
import FooterOne from '../../components/Footer/Footer';
import { FaPlus } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Grid, Typography, Button, Card, CardMedia, CardContent, useTheme, useMediaQuery } from '@mui/material';
import SidebarSuccessStories from '../../components/SuccessStories/SidebarSuccessStories ';

const CarolSuccessStory = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const costs = [
        { item: "School Health Inspection by Ministry of Education", cost: "$1,890" },
        { item: "Computers to College Students Studying at Home Due to Covid-19", cost: "$1,000" },
        { item: "Rent & Food Money to Families of Students Affected by Covid-19", cost: "$1,200" },
        { item: "Workshops for Girls on Covid-19 Sensitization", cost: "$750" },
        { item: "Online Learning Phones and Tablets for Students at Home", cost: "$900" },
        { item: "Solar Panels for Charging Phones for Students without Electricity at Home", cost: "$500" },
        { item: "Airtime to Students for Online Learning", cost: "$200" },
        { item: "Staff Workshops for Covid Awareness", cost: "$275" },
        { item: "Private Transportation for Staff Living in Towns Prone to Covid-19", cost: "$390" },
        { item: "Covid-19 Isolation Room Construction", cost: "$1,000" },
        { item: "Staff Covid-19 Testing Cost", cost: "$515" },
        { item: "5 Washing Stations", cost: "$250" },
        { item: "Hand Sanitizers", cost: "$360" },
        { item: "Hand Washing Soaps", cost: "$200" },
        { item: "Face Masks", cost: "$120" },
        { item: "Thermometers", cost: "$380" },
        { item: "Fire Extinguishers", cost: "$1,000" },
    ];

    return (
        <Box>
            <NavBar />
            <Box sx={{ mt: 8, mx: isMobile ? 'auto' : 5, p: 2 }}>
                <Typography variant="h3" gutterBottom sx={{ my: 3, textAlign: 'center', fontWeight: 'bold' }}> Carol Success Story And Covid Help</Typography>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={8}>
                        <Box sx={{ mb: 3 }}>
                            <Box sx={{ my: 5, overflow: 'hidden', borderRadius: '1rem' }}>
                                <iframe
                                    src="https://www.youtube.com/embed/-clHB4lC-g8"
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{ width: '100%', height: '450px', borderRadius: '1rem' }}
                                ></iframe>
                            </Box>
                            <Box>
                                <Typography variant="h4" sx={{ color: '#000', fontWeight: 'bold', mb: 3 }}>
                                    Please consider donating to help us meet COVID-19 requirements issued by the Kenyan Ministry of Education for opening school.
                                </Typography>

                                <Typography variant="body1" sx={{ mb: 1.5 }}>
                                    Below is a list of the items required;
                                </Typography>
                                <Typography variant="h5" sx={{ mb: 1 }}>
                                    Breakdown of Costs:
                                </Typography>
                                <Box component="ul" sx={{
                                    pl: 2,
                                    mb: 1.5,
                                    listStyleType: 'none',
                                    m: 0,
                                    '& li:before': {
                                        content: '"•"',
                                        color: 'black',
                                        fontWeight: 'bold',
                                        display: 'inline-block',
                                        width: '1em',
                                        marginLeft: '-1em'
                                    }
                                }}>
                                    {costs.map((cost, index) => (
                                        <Box component="li" key={index} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, alignItems: 'center' }}>
                                            <Typography component="span" sx={{ flexGrow: 1 }}>
                                                {cost.item}
                                            </Typography>
                                            <Typography component="span" sx={{ fontWeight: 'bold', color: 'black', ml: 2 }}>
                                                {cost.cost}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                                <Typography variant="body1" sx={{ display: 'flex', justifyContent: 'space-between', my: 1.5, fontWeight: 'bold', fontSize: '1.25em', color: 'black' }}>
                                    <span>TOTAL :</span>
                                    <span>$10,930</span>
                                </Typography>

                                <Typography variant="body1" sx={{ mb: 1.5 }}>
                                    Thank you for your support and any assistance you can provide will be greatly appreciated.
                                </Typography>

                                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
                                    <Button
                                        variant="outlined"
                                        component={RouterLink}
                                        to="/donate"
                                        endIcon={<FaPlus style={{ position: 'relative', top: '80%', transform: 'translateY(-80%)', fontSize: 'small' }} />}
                                        className="btn btn-border-base"
                                        sx={{
                                            borderRadius: '2.5rem',
                                            color: '#f39c12',
                                            border: '2px solid #f39c12',
                                            borderColor: '#f39c12',
                                            '& .MuiButton-endIcon': {
                                                mx: '0px',
                                            }
                                        }}
                                    >
                                        Learn More
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box sx={{ my: 10, mx: isMobile ? 'auto' : 3, }}>
                            <Card sx={{ textAlign: 'center', borderRadius: '1rem' }}>
                                <Typography variant="h6" sx={{ m: 2, color: '#000', fontWeight: 'bold', textAlign: 'center' }}>
                                    CAROL WAS SPONSORED BY BEADS WHEN SHE WAS IN GRADE 5.
                                </Typography>
                                <CardMedia
                                    component="img"
                                    image="assets/img/success-stories/carol-success.jpeg"
                                    alt="Carol"
                                    sx={{ width: '90%', height: 300, borderRadius: '1rem', mx: 2 }}
                                />
                                <CardContent>
                                    <Typography variant="body1" sx={{ my: 2 }}>
                                        Now she is an English teacher at the BEADS High School. Your support made this possible.
                                    </Typography>
                                    <Typography paragraph>Listen to her story.</Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <SidebarSuccessStories />
                    </Grid>
                </Grid>
            </Box>
            <FooterOne />
        </Box>
    );
};

export default CarolSuccessStory;